import React from 'react'
import _ from 'lodash'
// import immutable from 'immutable'

import QuickChat from '../widgets/chat/quickchat.container'
import {HeaderBlock} from '../widgets/layout/headerblock.component'
import {ListItemBlock} from '../widgets/layout/listitemblock.component'
import {RelatedContentBand} from '../widgets/relatedcontentband/relatedcontentband.component'

export class AccommodationList extends React.Component {
    constructor(props) {
        super(props)
    
        _.bindAll(this,
            'showDetails',
            'getListHeader',
            'getListItems',
            'removeFromItin',
            'addRelatedToItin',
            'getLeftSidebar',
            'getRightSidebar'
        )
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.leg.get('accommodations') !== nextProps.leg.get('accommodations')) {
            return true
        } else {
            return false
        }
    }

    showDetails(accomm) {
        this.props.onActivateAccommodation(accomm)
        this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.DETAILS)
    }

    removeFromItin(accom) {    
        this.props.onRemoveAccommodation(this.props.leg, accom)
    }

    addRelatedToItin(accom) {
        this.props.onSelectAccommodation(this.props.leg, accom, this.props.user)
    }

    getListHeader() {
        if (this.props.detailSection !== this.props.availableDetailSections.DESTINATION && this.props.detailSection !== this.props.availableDetailSections.OVERVIEW) {
            let header = 'Where to stay in ' + this.props.leg.getIn(['destination', 'title'])
            return (
                <HeaderBlock header={header} body="Start exploring our recommended accommodations below or add your own."/>
            )
        } else {
            return null
        }
    }

    getListItems() {
        if (!this.props.leg.get('accommodations').isEmpty()) {
            let legAccommodations = this.props.leg.get('accommodations').map((acc, index) => {
                return <ListItemBlock {...this.props} key={index} item={acc} showDetails={() => this.showDetails(acc) } removeFromItin={() => this.removeFromItin(acc) } type="accommodation"/>
            })
            let exploreBtn = null
            if (this.props.detailSection !== this.props.availableDetailSections.ACCOMMODATIONS) {
                let exploreBtn =  <div className="btn" onClick={() => {this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.SEARCH)}} >Explore</div>
            }
            return (
                <div className="list-items">
                    <div className="list-items-header">
                        <h3>Saved Accommodations in {this.props.leg.getIn(['destination', 'title'])}</h3>
                        {exploreBtn}
                    </div>
                    {legAccommodations}
                </div>
            )
        }
    }

    getRelated() {    
    // need to pass in the destination item to related content
        let destinationItem = this.props.leg.get('destination')    
        if (this.props.detailSection !== this.props.availableDetailSections.DESTINATION) {
            let count = this.props.leg.get('accommodations').size > 0 ? 3 : 9
            let showFail = this.props.leg.get('accommodations').size === 0
            return <RelatedContentBand item={ destinationItem } {...this.props} count={count} showFail={showFail} showMore={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.SEARCH) } addToItin={this.addRelatedToItin} removeFromItin={this.removeFromItin} destId={this.props.leg.getIn(['destination', 'id'])} type="nearby" model="accommodation"/>
        } else {
            // Nothing?
            return null
        }
    }

    getRightSidebar() {
        if (this.props.detailSection !== this.props.availableDetailSections.DESTINATION) {
            // if not mobile, put both buttons in the right col
            let altBtn = null 
            if (!window._isMobile) {
                altBtn = <a className="btn btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.SEARCH) }>
                    <i className="icon-search"/><span>FIND MORE</span>
                </a>
            }

            return (
                <div className="view-right-col">
                    {altBtn}
                    <a className="btn btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.ENTRY)}>
                        <i className="icon-circle_add"/><span>ADD MY OWN</span>
                    </a>
                </div>
            )
        } else {
            return ( <div className="view-right-col"/> )
        }
    }

    getLeftSidebar() {
        if (this.props.detailSection !== this.props.availableDetailSections.DESTINATION) {
            // if is mobile, but a button in the left col
            let altBtn = null
            if (window._isMobile) {
                altBtn = <a className="btn btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.SEARCH) }>
                    <i className="icon-search"/><span>FIND MORE</span>
                </a>
            }
            return (
                <div className="view-left-col">
                    {altBtn}
                </div>
            )
        } else {
            return ( <div className="view-right-col"/> )
        }
    }

    render() {
        return (
            <div className="view-area">
                {this.getLeftSidebar()}
                <div className="view-center">
                    {this.getListHeader()}
                    {this.getListItems()}
                    {this.getRelated()}
                </div>
                {this.getRightSidebar()}
            </div>
        )
    }
}